import React, { PropsWithChildren } from "react";
import * as Confirmation from "@/src/routes/orders/routes/[orderId]/routes/success/components/SuccessfulOrderLanding/components/orderConfirmationDetailsComponents";
import { ProductCardThumbnail } from "@/src/components/cards/components/ProductCard/components/ProductCardThumbnail";
import { TokenTransferToken } from "../..";

type TokenTransferConfirmationDetailsProps = {
  token?: TokenTransferToken;
  address?: string;
};

export default function TokenTransferConfirmationDetails({
  token,
  address,
}: TokenTransferConfirmationDetailsProps) {
  return (
    <Confirmation.DetailSection className="border-t border-b-0 border-gray-500 border-opacity-50">
      <Confirmation.DetailLineItem className="!justify-start gap-6">
        <ProductCardThumbnail
          isHovered={false}
          imageSrc={token?.image?.src}
          imageAlt={token?.image?.alt}
          className="w-[72px] h-[72px] laptop:w-28 laptop:h-28 rounded-md"
        />

        <TokenDetails>
          <TokenName token={token} />
          <TokenAddress address={address} />
        </TokenDetails>
      </Confirmation.DetailLineItem>
    </Confirmation.DetailSection>
  );
}

function TokenDetails({ children }: PropsWithChildren) {
  return (
    <div className="flex flex-col gap-2 laptop:gap-6 text-xs laptop:text-base">
      {children}
    </div>
  );
}

function TokenName({ token }: TokenTransferConfirmationDetailsProps) {
  return (
    <div>
      <p>{token?.name}</p>
      <p className="text-gray-400">{`#${token?.id}`}</p>
    </div>
  );
}

function TokenAddress({ address }: TokenTransferConfirmationDetailsProps) {
  return (
    <div>
      <p>Address</p>
      <p className="text-gray-400">{address}</p>
    </div>
  );
}
